import {getCountryCodeFromLocale} from '@/utilities/locales'
import type {JsonObject} from '../../auth/cdc-screensets/models'
import {setupBusinessSearch, validateBusiness} from './business-search'
import {
	confirmEmailFieldsMatch,
	setupEmailConfirmation,
} from './email-confirmation'
import {
	setFlatConsentValidationError,
	setupFlatConsentValidation,
} from './form-elements'

const JAPANESE_REQUIRED_CONSENT_MESSAGE = '入力必須です。'

function isConsentGranted(value: unknown): boolean {
	return value === true || value === 'true' || value === 1 || value === '1'
}

export class CDCScreenSetValidator {
	emailMatch = false

	businessIsValid = false

	flatConsentIsValid = true

	async setup(locale: string, noResultsText?: string): Promise<void> {
		setupEmailConfirmation()
		if (getCountryCodeFromLocale(locale) === 'JP') {
			setupFlatConsentValidation(JAPANESE_REQUIRED_CONSENT_MESSAGE)
		}
		try {
			await setupBusinessSearch(locale, noResultsText)
		} catch (error) {
			// eslint-disable-next-line no-console -- Intentional error logging for business search setup failure
			console.error(
				'Failed to set up business search; continuing without it.',
				error
			)
		}
	}

	isValid(enableBusinessValidation = true): boolean {
		return (
			this.emailMatch &&
			this.flatConsentIsValid &&
			(!enableBusinessValidation || this.businessIsValid)
		)
	}

	validate(formData?: JsonObject, locale?: string): void {
		this.emailMatch = confirmEmailFieldsMatch()
		this.businessIsValid = validateBusiness()
		this.flatConsentIsValid = this.validateFlatConsent(formData, locale)
	}

	private validateFlatConsent(
		formData?: JsonObject,
		locale?: string
	): boolean {
		if (getCountryCodeFromLocale(locale) !== 'JP') {
			return true
		}

		const hasDom = typeof document !== 'undefined'

		if (!hasDom) {
			return true
		}

		const hasFlatConsentField =
			document.querySelector(
				'input[name="preferences.email.isConsentGranted"][data-screenset-roles*="instance"]'
			) !== null

		if (!hasFlatConsentField) {
			setFlatConsentValidationError('')
			return true
		}

		const consentValue = formData?.['preferences.email.isConsentGranted']
		const isValidConsent = isConsentGranted(consentValue)

		setFlatConsentValidationError(
			isValidConsent ? '' : JAPANESE_REQUIRED_CONSENT_MESSAGE
		)
		return isValidConsent
	}
}
